import { createContext, useContext } from "react";

export interface URLParams {
  campaign_id?: string;
  contact_id?: string;
  template?: string;
  org_id?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_adgroup?: string;
  utm_term?: string;
  utm_content?: string;
  targetid?: string;
  adposition?: string;
  device?: string;
  network?: string;
  loc_physical_ms?: string;
  loc_interest_ms?: string;
  gclid?: string;
  adgroupname?: string;
  campaignname?: string;
  fbclid?: string;
  fb_campaign_id?: string;
  fb_ad_id?: string;
  campaign_type?: "email" | "ad" | "meta" | string;
  agent?: string; // Agent email for tracking referring agents
  [key: string]: string | undefined; // Allow for additional parameters
}

export interface URLParamsContextType {
  params: URLParams;
  updateParams: (newParams: URLParams) => void;
  appendParamsToUrl: (url: string) => string;
  getCampaignType: () => string | undefined;
  isEmailCampaign: () => boolean;
  isAdCampaign: () => boolean;
  isMetaCampaign: () => boolean;
}

export const URLParamsContext = createContext<URLParamsContextType>({
  params: {},
  updateParams: () => {},
  appendParamsToUrl: (url) => url,
  getCampaignType: () => undefined,
  isEmailCampaign: () => false,
  isAdCampaign: () => false,
  isMetaCampaign: () => false,
});

export const useURLParams = () => {
  const context = useContext(URLParamsContext);
  if (!context) {
    throw new Error("useURLParams must be used within a URLParamsProvider");
  }
  return context;
};
